import {useState} from "react";
import {ArrowIcon, DetailsContent, DetailsWrap, Icon, SummaryButton} from "./styled";

export const ReadMore = ({children})=>{

    const [open, setOpen] = useState(false);

    return (
        <DetailsWrap>
            <SummaryButton onClick={() => setOpen(!open)}>
                <Icon version="1.1" xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 32 32">
                    <path d="M0 12h22v4h-22zM0 6h22v4h-22zM0 18h22v4h-22zM0 24h22v4h-22zM24 14l4 6 4-6z"></path>
                </Icon>

                Read more

                <ArrowIcon $open={open} version="1.1" xmlns="http://www.w3.org/2000/svg" width="8" height="16" viewBox="0 0 11 32">
                    <path d="M10.625 17.143q0 0.232-0.179 0.411l-8.321 8.321q-0.179 0.179-0.411 0.179t-0.411-0.179l-0.893-0.893q-0.179-0.179-0.179-0.411t0.179-0.411l7.018-7.018-7.018-7.018q-0.179-0.179-0.179-0.411t0.179-0.411l0.893-0.893q0.179-0.179 0.411-0.179t0.411 0.179l8.321 8.321q0.179 0.179 0.179 0.411z"></path>
                </ArrowIcon>

            </SummaryButton>

            <DetailsContent $open={open}>
                {children}
            </DetailsContent>
        </DetailsWrap>
    )
}